export default function SimpleTable({ headers, rows, scrollable = false }) {
  return (
    <div className="overflow-x-auto rounded-2xl border bg-white shadow-sm relative">
      <div className={scrollable ? "max-h-64 overflow-y-auto" : ""}>
        <table className="min-w-full text-sm">
          <thead
            className={`bg-slate-50 ${
              scrollable ? "sticky top-0 z-10" : ""
            }`}
          >
            <tr className="text-left text-[11px] sm:text-xs uppercase tracking-wide text-slate-500">
              {headers.map((h, i) => (
                <th
                  key={i}
                  className="px-3 sm:px-2 py-2 sm:py-3 whitespace-nowrap bg-slate-50 text-center"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, ri) => (
              <tr key={ri} className="border-b last:border-0 hover:bg-slate-50">
                {r.map((c, ci) => (
                  <td
                    key={`${ri}-${ci}`}
                    className="px-3 sm:px-2 py-2 sm:py-3 whitespace-wrap overflow-hidden text-center"
                    title={typeof c === "string" ? c : ""}
                  >
                    {c}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}




// export default function SimpleTable({ headers, rows, currentPage, totalPages, onPageChange }) {
//   return (
//     <div className="overflow-x-auto overflow-y-auto rounded-2xl border bg-white shadow-sm">
//       <table className="min-w-full text-sm ">
//         <thead className="bg-slate-50">
//           <tr className="text-left text-[11px] sm:text-xs uppercase tracking-wide text-slate-500">
//             {headers.map((h, i) => (
//               <th key={i} className="px-3 sm:px-2 py-2 sm:py-3 whitespace-nowrap">
//                 {h}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {rows.map((r, ri) => (
//             <tr key={ri} className="border-b last:border-0">
//               {r.map((c, ci) => (
//                 <td
//                   key={`${ri}-${ci}`}
//                   className="px-3 sm:px-2 py-2 sm:py-3 whitespace-nowrap max-w-[150px] overflow-hidden text-ellipsis truncate"
//                   title={typeof c === "string" ? c : ""}
//                 >
//                   {c}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center px-4 py-2 border-t bg-slate-50 text-xs sm:text-sm">
//           <button
//             disabled={currentPage === 1}
//             onClick={() => onPageChange(currentPage - 1)}
//             className={`px-3 py-1 rounded-lg border ${
//               currentPage === 1
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-white hover:bg-slate-100"
//             }`}
//           >
//             Prev
//           </button>

//           <span>
//             Page {currentPage} of {totalPages}
//           </span>

//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => onPageChange(currentPage + 1)}
//             className={`px-3 py-1 rounded-lg border ${
//               currentPage === totalPages
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-white hover:bg-slate-100"
//             }`}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

